// extracted by mini-css-extract-plugin
export default {"warning":"WarningText_warning__z3PMt","danger":"WarningText_danger__YTbUn"};